<template>
    <div>
        <v-row class="px-2 pt-2">
            <v-col md="4" class="py-0">
                <v-autocomplete
                    v-model="merchant"
                    label="Select a merchant"
                    :items="merchants"
                    item-value="uuid"
                    item-text="name"
                    dense
                    @change="getReport(); loading = true;"
                ></v-autocomplete>
            </v-col>

            <!-- From Date -->
            <v-col md="2" class="py-1">
                <v-menu
                    v-model="fromDateModal"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                ><template v-slot:activator="{ on }">
                    <v-text-field
                        v-model="search.fromDate"
                        label="From Date"
                        append-icon="mdi-calendar"
                        readonly
                        v-on="on"
                        class="mt-0 pt-0"
                    ></v-text-field
                ></template>
                    <v-date-picker
                        v-model="search.fromDate"
                        @input="fromDateModal = false"
                        @click:date="handleDateFilters"
                    ></v-date-picker>
                </v-menu>
            </v-col>

            <!-- To Date -->
            <v-col md="2" class="py-1">
                <v-menu
                    v-model="toDateModal"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                ><template v-slot:activator="{ on }">
                    <v-text-field
                        v-model="search.toDate"
                        label="To Date"
                        append-icon="mdi-calendar"
                        readonly
                        v-on="on"
                        class="mt-0 pt-0"
                    ></v-text-field
                ></template>
                    <v-date-picker
                        v-model="search.toDate"
                        @input="toDateModal = false"
                        @click:date="handleDateFilters"
                    ></v-date-picker>
                </v-menu>
            </v-col>
        </v-row>

        <v-row class="px-4">
            <v-col md="12" class="pa-2">
                <v-data-table
                    v-if="report"
                    :headers="headers"
                    :items="report"
                    :items-per-page="5"
                    hide-default-footer
                    class="elevation-0"
                >
                    <template v-slot:item.totalValue="{ item }">
                        {{ new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(item.totalValue) }}<br>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>

        <v-overlay :value="loading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            merchants: null,
            merchant: null,
            report: null,
            fromDateModal: false,
            toDateModal: false,
            loading: false,
            search: { fromDate: new Date().toISOString().substr(0, 10),
                      toDate: new Date().toISOString().substr(0, 10) },
            headers: [{ text: 'Username', value: 'username', sortable: false, align: 'left' },
                      { text: 'Total Transactions', value: 'totalTransactions', sortable: false, align: 'center' },
                      { text: 'Total Value', value: 'totalValue', sortable: false, align: 'center' },
                      { text: 'Successful', value: 'successful', sortable: false, align: 'center' },
                      { text: 'Failed - Limit Exceeded', value: 'limitExceeded', sortable: false, align: 'center' },
                      { text: 'Failed - Do Not Honor', value: 'doNotHonor', sortable: false, align: 'center' },
                      { text: 'Visa', value: 'visa', sortable: false, align: 'center' },
                      { text: 'Mastercard', value: 'master', sortable: false, align: 'center' }]
        }
    },
    beforeMount() {
        this.getMerchants();
    },
    methods: {
        getMerchants() {
            if(this.$store.getters.role <= 2) {
                axios({
                method: 'get',
                url: `get-merchants-live`,
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.merchants = response.data;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
            else {
                axios({
                method: 'post',
                url: `get-merchants-live-client`,
                data: { userId: this.$store.state.user.id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.merchants = response.data;
                    this.merchant = this.merchants.length == 1 ? this.merchants[0] : null;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
        },
        getReport() {
            axios({
            method: 'post',
            url: `report-moto-transactions-client`,
            data: { merchant: this.merchant, search: this.search },
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                this.report = response.data;
                this.loading = false;
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
        handleDateFilters() {
            if(this.search.toDate < this.search.fromDate) {
                this.search.fromDate = this.search.toDate;
            }
            this.loading = true;
            this.getReport();
        }
    }
}
</script>